import Page, { getProps } from '@/modules/investment/why-invest'

export const getServerSideProps = getProps

export default Page
